export default {"src":"/_next/static/media/droneOutline100_40.26f64277.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};